import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import "./activity.css";

const RFQActivityLog = ({ rfqId, children }) => {
  const [show, setShow] = useState(false);
  const [activityLog, setActivityLog] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleOpen = async () => {
    if (!rfqId) return;

    setShow(true);

    if (activityLog.length) return;

    try {
      setLoading(true);
      const res = await apicall.get(`getRFQActivityLog/${rfqId}`);
      setActivityLog(res?.data || []);
    } catch (err) {
      toast.error("Failed to fetch activity log");
    } finally {
      setLoading(false);
    }
  };
const grouped = activityLog.reduce(
  (acc, log) => {
    if (!acc[log.type]) acc[log.type] = [];
    acc[log.type].push(log);
    return acc;
  },
  {}
);

  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-GB");
  };
const ActivityItem = ({ log, formatDate, isRFQCreated = false }) => {
  // take only first product if multiple are coming
  const firstProduct =
    log.product_name?.split(",")[0]?.trim();

  return (
    <div className="activity-item">
      <div className="avatar">
        {log.company_name?.charAt(0) || "S"}
      </div>

      <div className="content">
                {isRFQCreated && log.user_name && (
          <div className="meta">{log.user_name}</div>
        )}
        <div className="title">{log.title}</div>
        <div className="desc">{log.description}</div>

        {isRFQCreated && firstProduct && (
          <div className="meta">{firstProduct}</div>
        )}

        {!isRFQCreated && log.price && (
          <div className="meta">💰 Price: ${log.price}</div>
        )}

        {!isRFQCreated && log.delivery_time && (
          <div className="meta">
            📦 Delivery Time: {log.delivery_time}
          </div>
        )}

        {!isRFQCreated && (
          <div className="company">{log.company_name}</div>
        )}
      </div>

      <div className="date">{formatDate(log.date)}</div>
    </div>
  );
};


  return (
    <>
      {/* Trigger */}
      <div>{children(handleOpen)}</div>

      {/* Right Drawer */}
      {show && (
        <div className="activity-overlay" onClick={() => setShow(false)}>
          <div
            className="activity-drawer"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="activity-header">
              <h5>Activity log</h5>
              <span className="close-btn" onClick={() => setShow(false)}>
                ×
              </span>
            </div>

           <div className="activity-body">
  {loading ? (
    <div className="text-center mt-4">
      <Spinner animation="border" />
    </div>
  ) : activityLog.length > 0 ? (
    <>
      {/* RFQ Created */}
      {grouped.RFQ_CREATED?.map((log, idx) => (
        <ActivityItem key={`rfq-${idx}`} log={log} formatDate={formatDate}
        isRFQCreated={true}
        />
      ))}

      {grouped.RFQ_UPDATED?.map((log, idx) => (
        <ActivityItem key={`rfq-${idx}`} log={log} formatDate={formatDate}
        isRFQCreated={true}
        />
      ))}

      {grouped.QUOTATION_SUBMITTED?.length > 0 && (
        <div className="activity-group">

          {grouped.QUOTATION_SUBMITTED.map((log, idx) => (
            <ActivityItem
              key={`submitted-${idx}`}
              log={log}
              formatDate={formatDate}
            />
          ))}
        </div>
      )}

      {/* Qualified */}
      {grouped.QUOTATION_QUALIFIED?.map((log, idx) => (
        <ActivityItem key={`qualified-${idx}`} log={log} formatDate={formatDate} />
      ))}

      {/* Approved */}
      {grouped.QUOTATION_APPROVED?.map((log, idx) => (
        <ActivityItem key={`approved-${idx}`} log={log} formatDate={formatDate} />
      ))}
    </>
  ) : (
    <p className="text-muted">No activity found.</p>
  )}
</div>

          </div>
        </div>
      )}
    </>
  );
};

export default RFQActivityLog;
